export default __webpack_public_path__ + "static/media/photo--lg--13.b5f545ca.jpg";